import { render, staticRenderFns } from "./billingDetailComponent.vue?vue&type=template&id=0cf2c474&scoped=true"
import script from "./billingDetailComponent.vue?vue&type=script&lang=js"
export * from "./billingDetailComponent.vue?vue&type=script&lang=js"
import style0 from "./billingDetailComponent.vue?vue&type=style&index=0&id=0cf2c474&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf2c474",
  null
  
)

export default component.exports